// Constants
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
import { ViewDisplayState } from "@ms/uno-constants/lib/local/ViewConstants";
import { MyTasksViewPivotType } from "@ms/uno-constants/lib/local/ViewPivots";
// Components
import { NoTasksDark, NoTasksLight, NoFlaggedEmail, NoFlaggedEmailDarkMode } from "@ms/planner-generic-controls/lib/local/icons/index";
// Resources
import { Strings } from "./CultureUtilities";
import React from "react";
/*
 * Get the empty state properties based on the current pivot and empty state view type
 * @param theme Current theme
 * @param viewId Current view identifier
 * @param myTasksViewDisplayState Current data state of My Tasks
 */ export const getEmptyStateProps = (theme, viewId, myTasksViewDisplayState)=>{
    return {
        emptyStateTitle: getEmptyStateTitle(viewId, myTasksViewDisplayState),
        emptyStateDescription: getEmptyStateDescription(viewId, myTasksViewDisplayState),
        image: getEmptyStateImage(theme, viewId, myTasksViewDisplayState)
    };
};
const getEmptyStateImage = (theme, viewId, myTasksViewDisplayState)=>{
    if (myTasksViewDisplayState === ViewDisplayState.DataNotAvailable && viewId.partitionKey === MyTasksViewPivotType.FlaggedEmails) {
        return theme === PlannerTheme.Light ? /*#__PURE__*/ React.createElement(NoFlaggedEmail, null) : /*#__PURE__*/ React.createElement(NoFlaggedEmailDarkMode, null);
    }
    return theme === PlannerTheme.Light ? /*#__PURE__*/ React.createElement(NoTasksLight, null) : /*#__PURE__*/ React.createElement(NoTasksDark, null);
};
/**
 * Get the empty state title based on the current pivot and empty state view type
 * @param viewId Current view identifier
 * @param myTasksViewDisplayState Current data state of My Tasks
 */ const getEmptyStateTitle = (viewId, myTasksViewDisplayState)=>{
    if (myTasksViewDisplayState === ViewDisplayState.DataAvailableButFiltered) {
        switch(viewId.partitionKey){
            case MyTasksViewPivotType.AssignedToMe:
                return Strings.EmptyStateView_NoTasksForAssignedToMeFiltersTitle;
            case MyTasksViewPivotType.FlaggedEmails:
                return Strings.EmptyStateView_NoTasksForFlaggedEmailsFiltersTitle;
            default:
                return Strings.EmptyStateView_NoTasksForAppliedFiltersTitle;
        }
    }
    switch(viewId.partitionKey){
        case MyTasksViewPivotType.PrivateTasks:
            return Strings.EmptyStateView_NoTasksTitlePrivateTasks;
        case MyTasksViewPivotType.AssignedToMe:
            return Strings.EmptyStateView_NoTasksTitleAssignedToMe;
        case MyTasksViewPivotType.FlaggedEmails:
            return Strings.EmptyStateView_NoTasksTitleFlaggedEmails;
        case MyTasksViewPivotType.All:
        default:
            return Strings.EmptyStateView_NoTasksTitleMyTasks;
    }
};
/**
 * Get the empty state description based on the current pivot and empty state view type
 * @param viewId Current view identifier
 * @param myTasksViewDisplayState Current data state of My Tasks
 */ const getEmptyStateDescription = (viewId, myTasksViewDisplayState)=>{
    if (myTasksViewDisplayState === ViewDisplayState.DataAvailableButFiltered) {
        switch(viewId.partitionKey){
            case MyTasksViewPivotType.AssignedToMe:
                return Strings.EmptyStateView_NoTasksDescriptionFiltersAssignedToMe;
            case MyTasksViewPivotType.PrivateTasks:
                return Strings.EmptyStateView_NoTasksDescriptionFiltersPrivateTasks;
            case MyTasksViewPivotType.All:
                return Strings.EmptyStateView_NoTasksDescriptionFiltersAllTasks;
            case MyTasksViewPivotType.FlaggedEmails:
            default:
                return Strings.EmptyStateView_NoTasksForAppliedFiltersDescription;
        }
    }
    switch(viewId.partitionKey){
        case MyTasksViewPivotType.PrivateTasks:
            return Strings.EmptyStateView_NoTasksDescriptionPrivateTasks;
        case MyTasksViewPivotType.AssignedToMe:
            return Strings.EmptyStateView_NoTasksDescriptionAssignedToMe;
        case MyTasksViewPivotType.FlaggedEmails:
            return Strings.EmptyStateView_NoTasksDescriptionFlaggedEmails;
        case MyTasksViewPivotType.All:
        default:
            return Strings.EmptyStateView_NoTasksDescriptionMyTasks;
    }
};
